module.exports = __webpack_public_path__ + "media/images/svgs/wave-underline-e517e4543b62726324a61ed6aa642592.svg";